import Quill from 'quill';

class MaxLength {
    constructor(quill: any, options: { maxLength: number }) {
        quill.on('text-change', () => {
            const { maxLength } = options;
            const length = quill.getLength();
            if (length > maxLength) {
                quill.deleteText(maxLength, length);
            }
        });
    }
}

Quill.register('modules/maxLength', MaxLength);
